exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reject_box[data-v-d8c8f7e2]{background:#fafafa;padding:.2rem .24rem;margin-bottom:.24rem}.reject_box .sub_title[data-v-d8c8f7e2]{justify-content:flex-start !important;align-items:center}.point-page .sub_title[data-v-d8c8f7e2]{font-size:.18rem;font-family:Roboto-Bold,Roboto;font-weight:bold;color:#000;line-height:.28rem;margin-bottom:.16rem;display:flex;justify-content:space-between}.point-page .sub_title.img[data-v-d8c8f7e2]{justify-content:flex-start}.point-page .refusalReason[data-v-d8c8f7e2]{font-size:.14rem;line-height:.24rem;padding-left:.28rem}.point-page .point-form[data-v-d8c8f7e2]{padding:0 .32rem}", ""]);

// exports
